import React, { useState } from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/global.css"; // Custom styles

const ChangePassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!newPassword || !confirmPassword) {
      setError("All fields are required!");
      return;
    }

    if (newPassword.length < 6) {
      setError("New password must be at least 6 characters long.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("New passwords do not match.");
      return;
    }

    // Simulate password update request
    setMessage("Your password has been successfully changed.");
    setError("");
  };

  return (
    <div className="change-password-container d-flex align-items-center justify-content-center min-vh-100 bg-light">
      <div className="card shadow-lg p-4 rounded" style={{ maxWidth: "400px", width: "100%" }}>
        <div className="text-center">
          <h2 className="fw-bold text-primary">Irfan Electricals</h2>
          <p className="text-muted">Change Your Password</p>
        </div>

        {error && <div className="alert alert-danger p-2">{error}</div>}
        {message && <div className="alert alert-success p-2">{message}</div>}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-semibold">New Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">Confirm New Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>

          <button type="submit" className="btn btn-primary w-100 fw-bold">Change Password</button>
        </form>

        <p className="mt-3 text-center">
          <Link to="/login" className="text-primary">Back to Login</Link>
        </p>
      </div>
    </div>
  );
};

export default ChangePassword;
